





























import Vue from "vue"
import Datatable, {DatatableOptions} from "@/components/datatable/Datatable.vue"
import {News} from "@/model/entity/news/news"
import {INewsService, newsService} from "@/model/service/news/news-service"
import {FieldDescription} from "@/model/entity/field-descriptor"

interface Data {
  newsService: INewsService
  entity: News
  fields: FieldDescription[],
  options: DatatableOptions
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): Data {
    return {
      newsService: newsService,
      entity: new News(),
      fields: News.getFieldDescriptionList(),
      options: {
        operations: {
          delete: true
        }
      }
    }
  },
  methods: {
    openNewsEditorDialog(entity: News) {
      this.$router.push({path: `/news_editor/${entity.id}`})
    },
    openNewsAddDialog() {
      this.$router.push({path: `/news_editor`})
    }
  }
})
